import { configureStore } from '@reduxjs/toolkit';
import authReducer from "./reducers/authReducer";

const isDevEnv = () => {
    return process.env.NODE_ENV === 'development';
}

const store = configureStore({
    reducer:{
        auth:authReducer
    },
    devTools: isDevEnv()
})




// Infer types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;